/*
 * @Author: qinqianwen
 * @Date: 2020-08-10 15:09:17
 * @LastEditTime: 2021-03-01 17:50:20
 * @LastEditors: lidan
 * @Description: 车辆管理Api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\vehicleManage.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_BASE_WEB = "",
  E6_MS_TMS_E6YUN_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//获取车辆管理列表数据
export function getVehicleList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getPageByCondition`,
    method: "post",
    data
  });
}
//新增车辆信息
export function saveAddVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/insertInfo`,
    method: "post",
    data
  });
}
//修改车辆信息
export function saveUpdateVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/modifyInfo`,
    method: "post",
    data
  });
}
//根据id获取详情
export function getVehicleDetailById(id) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getDetailInfo`,
    method: "get",
    params: { id }
  });
}
//删除车辆信息
export function deleteVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/deleteBatch`,
    method: "post",
    data
  });
}
//车牌号唯一性校验
export function validCustomName(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/validCustomName`,
    method: "get",
    params
  });
}
//发动机号唯一性校验
export function checkEngineNo(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/validEngineNo`,
    method: "get",
    params
  });
}
//行驶证号唯一性校验
export function checkVlnNo(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/validVln`,
    method: "get",
    params
  });
}

//获取车辆下拉数据
export function getVehicleTreeList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getPageByCondition`,
    method: "post",
    data
  });
}

//导出车辆信息
export function exportVehicleInfo(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/exportVehicle`,
    method: "post",
    data
  });
}
//获取所属部门下拉数据
export function getOrgTreeList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/carInfo/getDepartment`,
    method: "post",
    data
  });
}
//获取所属承运商下拉数据
export function getCarrierTreeList() {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCarrierByPage`,
    method: "get"
  });
}
//获取车辆更改记录
export function fetchVehicleUpdateRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getHistoryList`,
    method: "post",
    data
  });
}

//获取车型下拉数据
export function findPageCarModelData(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/findPage`,
    method: "post",
    data
  });
}

//获取司机下拉数据（承运商）
export function findAllDriverByCarrier(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/findDriverByCarrier`,
    method: "post",
    data
  });
}
//获取司机下拉数据
export function findAllDriverByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/findAllDriverByPage`,
    method: "post",
    data
  });
}
